import { ASK_FOR } from './utils';
import { htmlParserOptions } from 'utils/constants';
export const getMatchMakingV2Translations = (intl) => ({
  Common: {
    title: intl.formatMessage({
      description: 'MatchMaking V2 Common title',
      defaultMessage: 'Matchmaking',
    }),
    description: intl.formatMessage({
      description: 'MatchMaking V2 Common description',
      defaultMessage:
        'Through the Matchmaking feature, exhibitors can scan entry tickets to view and save visitor data in real time. This feature is available in the Salone del Mobile.Milano app, which can be downloaded from the Apple Store and Google Play Store. The app can be installed on Apple or Android smartphones, with a maximum of 5 devices allowed. Installation on tablets is permitted in compatibility mode',
    }),
    linkText: intl.formatMessage({
      description: 'MatchMaking V2 Common linkText',
      defaultMessage: 'Discover what Matchmaking is',
    }),
    subtitle: intl.formatMessage({
      description: 'MatchMaking V2 Common subtitle',
      defaultMessage: 'personal area',
    }),
    tabReportTitle: intl.formatMessage({
      description: 'MatchMaking V2 Common subtitle',
      defaultMessage: 'Record scans',
    }),
    tabUserTitle: intl.formatMessage({
      description: 'MatchMaking V2 Common subtitle',
      defaultMessage: 'Your users',
    }),
    tabIntegrstionTitle: intl.formatMessage({
      description: 'MatchMaking V2 Common tabIntegrstionTitle',
      defaultMessage: 'CRM integration',
    }),
    userName: intl.formatMessage({
      description: 'MatchMaking V2 Common userName',
      defaultMessage: 'User name',
    }),
    userNameHelp: intl.formatMessage({
      description: 'MatchMaking V2 Common userNameHelp',
      defaultMessage:
        'This serves to generate the authentication email and will be shown in the .csv file that merges all the matchmaking carried out',
    }),
    password: intl.formatMessage({
      description: 'MatchMaking V2 Common password',
      defaultMessage: 'Password',
    }),
    passwordNotValid: intl.formatMessage({
      description: 'MatchMaking V2 Common passwordNotValid',
      defaultMessage: 'Password not valid',
    }),
    passwordHelp: intl.formatMessage({
      description: 'MatchMaking V2 Common passwordHelp',
      defaultMessage:
        'Use at least: 8 characters, a letter, a number, at least one special character (e.g.',
    }),
    passwordCopied: intl.formatMessage({
      description: 'MatchMaking V2 Common passwordCopied',
      defaultMessage: 'Password copied',
    }),
    passwordCopiedBody: intl.formatMessage({
      description: 'MatchMaking V2 Common passwordCopiedBody',
      defaultMessage: 'Password copied to clipboard successfully',
    }),
    error: intl.formatMessage({
      description: 'MatchMaking V2 Common error',
      defaultMessage: 'Something went wrong! Please, try again later.',
    }),
    greyBox: {
      title: intl.formatMessage({
        description: 'MatchMaking V2 Common greyBox title',
        defaultMessage: 'Please note',
      }),
      subtitle: intl.formatMessage(
        {
          description: 'MatchMaking V2 Common greyBox subtitle',
          defaultMessage:
            "For security reasons, the password will not be displayed in plain text in your Reserved Area. <div>To make sure that you don't lose it, you can copy it by using the appropriate icon.</div>",
        },
        { ...htmlParserOptions }
      ),
    },
    whiteCard: {
      reset: intl.formatMessage({
        description: 'MatchMaking V2 Common whiteCard button reset',
        defaultMessage: 'Reset password',
      }),
      delete: intl.formatMessage({
        description: 'MatchMaking V2 Common whiteCard button delete',
        defaultMessage: 'Delete',
      }),
      scansDay: intl.formatMessage({
        description: 'MatchMaking V2 Common whiteCard button scansDay',
        defaultMessage: 'scans day',
      }),
      totalScan: intl.formatMessage({
        description: 'MatchMaking V2 Common whiteCard button totalScan',
        defaultMessage: 'total scans',
      }),
    },
  },
  USERS: {
    profile: intl.formatMessage({
      description: 'MatchMaking V2 USERS profile',
      defaultMessage: 'Profile ',
    }),
    gold: intl.formatMessage({
      description: 'MatchMaking V2 USERS gold',
      defaultMessage: 'Gold',
    }),
    silver: intl.formatMessage({
      description: 'MatchMaking V2 USERS silver',
      defaultMessage: 'Silver',
    }),
    basic: intl.formatMessage({
      description: 'MatchMaking V2 USERS basic',
      defaultMessage: 'Basic',
    }),
    subtitleMax: intl.formatMessage({
      description: 'MatchMaking V2 USERS subtitleMax',
      defaultMessage:
        'You have reached the maximum number of users that can be created',
    }),
    subtitle: intl.formatMessage({
      description: 'MatchMaking V2 USERS subtitle',
      defaultMessage: 'Your profile includes',
    }),
    subtitleUsers: intl.formatMessage({
      description: 'MatchMaking V2 USERS subtitleUsers',
      defaultMessage: 'users',
    }),
    stillCreate: intl.formatMessage({
      description: 'MatchMaking V2 USERS stillCreate',
      defaultMessage: 'You can create',
    }),
    basicSubOne: intl.formatMessage({
      description: 'MatchMaking V2 USERS basicSubOne',
      defaultMessage:
        'This profile does not allow you to manage additional users.',
    }),
    basicSubTwo: intl.formatMessage(
      {
        description: 'MatchMaking V2 USERS basicSubTwo',
        defaultMessage:
          'Contact <info>digitalinfo@salonemilano.it</info> for more information.',
      },
      { ...htmlParserOptions }
    ),
    basicSubThree: intl.formatMessage({
      description: 'MatchMaking V2 USERS basicSubThree',
      defaultMessage:
        'You can use the matchmaking service with the basic exhibitor account.',
    }),
    basicSubFour: intl.formatMessage({
      description: 'MatchMaking V2 USERS basicSubFour',
      defaultMessage:
        'Please note that the exhibitor user can only log in from a maximum of 5 devices at the same time.',
    }),
    basicSubFive: intl.formatMessage(
      {
        description: 'MatchMaking V2 USERS basicSubFive',
        defaultMessage:
          'Watch the <linkeng>video tutorial</linkeng> to learn how to use the service.',
      },
      { ...htmlParserOptions }
    ),
    matchmakingUsers: intl.formatMessage({
      description: 'MatchMaking V2 USERS matchmakingUsers',
      defaultMessage: 'matchmaking users',
    }),
    buttons: {
      switch: intl.formatMessage({
        description: 'MatchMaking V2 USERS buttons switch',
        defaultMessage: 'Switch to Gold',
      }),
      create: intl.formatMessage({
        description: 'MatchMaking V2 USERS buttons create',
        defaultMessage: 'Create new user',
      }),
      ask: intl.formatMessage({
        description: 'MatchMaking V2 USERS buttons ask',
        defaultMessage: 'Request information',
      }),
    },
    basicSubtitle: intl.formatMessage({
      description: 'MatchMaking V2 USERS basicSubtitle',
      defaultMessage:
        'To use the matchmaking service, log in to the app with your email ',
    }),
    basicInfoTitle: intl.formatMessage({
      description: 'MatchMaking V2 USERS basicInfoTitle',
      defaultMessage: 'Do you need more user licenses?',
    }),
    basicInfoText: intl.formatMessage({
      description: 'MatchMaking V2 USERS basicInfoText',
      defaultMessage:
        'If you need to log in on multiple devices simultaneously, you can purchase additional matchmaking licenses. For more information, please contact',
    }),
    premiumSubtitleFirst: intl.formatMessage({
      description: 'MatchMaking V2 USERS premiumSubtitleFirst',
      defaultMessage: 'You have purchased ',
    }),
    premiumSubtitleSecond: intl.formatMessage({
      description: 'MatchMaking V2 USERS premiumSubtitleSecond',
      defaultMessage: ' Yadditional matchmaking licenses.',
    }),
  },
  REPORTS: {
    noReportsTitle: intl.formatMessage({
      description: 'MatchMaking V2 REPORTS title',
      defaultMessage:
        'Only the users that have performed scans will appear in this section.',
    }),
    outOf: intl.formatMessage({
      description: 'MatchMaking V2 REPORTS outOf',
      defaultMessage: 'out of',
    }),
    titleTwo: intl.formatMessage({
      description: 'MatchMaking V2 REPORTS first titleTwo',
      defaultMessage: 'users that you have created have performed scans.',
    }),
    downloadCsv: intl.formatMessage({
      description: 'MatchMaking V2 REPORTS first downloadCsv',
      defaultMessage: 'Download .csv',
    }),
    generateCsv: intl.formatMessage({
      description: 'MatchMaking V2 REPORTS first generateCsv',
      defaultMessage: 'Generate .csv',
    }),
    updateCsv: intl.formatMessage({
      description: 'MatchMaking V2 REPORTS first updateCsv',
      defaultMessage: 'Update .csv',
    }),
  },
  Dialog: {
    info: {
      [ASK_FOR.GOLD]: {
        title: intl.formatMessage({
          description: 'MatchMaking V2 Dialog info activateGold title',
          defaultMessage: 'Request information to activate the Gold package',
        }),
        subOne: intl.formatMessage({
          description: 'MatchMaking V2 Dialog info activateGold subOne',
          defaultMessage:
            'With the Gold package you will be able to independently activate 50 matchmaking users within the reserved area.',
        }),
        subTwo: intl.formatMessage({
          description: 'MatchMaking V2 Dialog info activateGold subTwo',
          defaultMessage:
            'Send the request for information, you will be contacted as soon as possible.',
        }),
      },
      [ASK_FOR.SILVER]: {
        title: intl.formatMessage({
          description: 'MatchMaking V2 Dialog info activateSilver title',
          defaultMessage: 'Request information to activate the Silver package',
        }),
        subOne: intl.formatMessage({
          description: 'MatchMaking V2 Dialog info activateSilver subOne',
          defaultMessage:
            'With the Silver package you will be able to independently activate 10 matchmaking users within the reserved area.',
        }),
        subTwo: intl.formatMessage({
          description: 'MatchMaking V2 Dialog info activateSilver subTwo',
          defaultMessage:
            'Send the request for information, you will be contacted as soon as possible.',
        }),
      },
      buttons: {
        cancel: intl.formatMessage({
          description: 'MatchMaking V2 Dialog info buttons cancel',
          defaultMessage: 'Cancel',
        }),
        send: intl.formatMessage({
          description: 'MatchMaking V2 Dialog info buttons send',
          defaultMessage: 'Send request',
        }),
      },
    },
    create: {
      title: intl.formatMessage({
        description: 'MatchMaking V2 Dialog create title',
        defaultMessage: 'Create user',
      }),
      subtitle: intl.formatMessage({
        description: 'MatchMaking V2 Dialog create subtitle',
        defaultMessage:
          'With this data, your matchmaking user will be able to access the app and perform scans during the fair.',
      }),
      buttons: {
        cancel: intl.formatMessage({
          description: 'MatchMaking V2 Dialog create buttons cancel',
          defaultMessage: 'Cancel',
        }),
        create: intl.formatMessage({
          description: 'MatchMaking V2 Dialog create buttons agree',
          defaultMessage: 'Create',
        }),
      },
    },
    edit: {
      title: intl.formatMessage({
        description: 'MatchMaking V2 Dialog edit title',
        defaultMessage: 'Change Password',
      }),
      subtitle: intl.formatMessage({
        description: 'MatchMaking V2 Dialog edit subtitle',
        defaultMessage:
          'The new password overwrites the one you used previously.',
      }),
      buttons: {
        cancel: intl.formatMessage({
          description: 'MatchMaking V2 Dialog edit buttons cancel',
          defaultMessage: 'Cancel',
        }),
        create: intl.formatMessage({
          description: 'MatchMaking V2 Dialog edit buttons agree',
          defaultMessage: 'Save new password',
        }),
      },
    },
    delete: {
      title: intl.formatMessage({
        description: 'MatchMaking V2 Dialog delete title',
        defaultMessage: 'Do you want to delete this matchmaking user?',
      }),
      subtitle: intl.formatMessage({
        description: 'MatchMaking V2 Dialog delete subtitle',
        defaultMessage:
          'This operation does not delete the matchmaking made by this user, which will remain present in the .csv file',
      }),
      buttons: {
        cancel: intl.formatMessage({
          description: 'MatchMaking V2 Dialog delete buttons cancel',
          defaultMessage: 'Cancel',
        }),
        agree: intl.formatMessage({
          description: 'MatchMaking V2 Dialog delete buttons agree',
          defaultMessage: 'Yes, I delete this user',
        }),
      },
    },
  },
  Alerts: {
    create: {
      title: intl.formatMessage({
        description: 'MatchMaking V2 Alerts create title',
        defaultMessage: 'User correctly created with the e-mail',
      }),
    },
    edit: {
      title: intl.formatMessage({
        description: 'MatchMaking V2 Alerts edit title',
        defaultMessage: 'User password correctly edited',
      }),
    },
    delete: {
      title: intl.formatMessage({
        description: 'MatchMaking V2 Alerts delete title',
        defaultMessage: 'Deleted user',
      }),
      message: intl.formatMessage({
        description: 'MatchMaking V2 Alerts delete message',
        defaultMessage:
          'The matchmaking performed by this user is still present in the .csv file',
      }),
    },
    /**
     * Warning, an error occurred
     */
    deletError: {
      title: intl.formatMessage({
        description: 'MatchMaking V2 Alerts deletError title',
        defaultMessage: 'Warning, an error occurred editing the password',
      }),
      message: intl.formatMessage({
        description: 'MatchMaking V2 Alerts deletError message',
        defaultMessage: 'You cannot use your last password',
      }),
    },
    copy: intl.formatMessage({
      description: 'MatchMaking V2 Alerts copy',
      defaultMessage: 'Item copied successfully to clipboard',
    }),
  },
  CustomErrors: {
    emptySpace: intl.formatMessage({
      description: 'MatchMaking V2 CustomErrors emptySpace',
      defaultMessage: 'The password cannot contain spaces',
    }),
  },
  MappedErrors: {
    Code2: intl.formatMessage({
      description: 'MatchMaking V2 MappedErrors Code2',
      defaultMessage: 'Attention: this password has already been used',
    }),
    Code4: intl.formatMessage({
      description: 'MatchMaking V2 MappedErrors Code4',
      defaultMessage: 'Attention: you need to choose a name for your user',
    }),
    Code6: intl.formatMessage({
      description: 'MatchMaking V2 MappedErrors Code6',
      defaultMessage:
        "Attention: your name can't exceed the 80 characters limit",
    }),
    Code7: intl.formatMessage({
      description: 'MatchMaking V2 MappedErrors Code7',
      defaultMessage: 'Attention: your name and password need to be different',
    }),
    Code8: intl.formatMessage({
      description: 'MatchMaking V2 MappedErrors Code8',
      defaultMessage: 'Please choose a valid password',
    }),
    Code9: intl.formatMessage({
      description: 'MatchMaking V2 MappedErrors Code9',
      defaultMessage:
        'Attention: the password does not meet security requirements',
    }),
    Code11: intl.formatMessage({
      description: 'MatchMaking V2 MappedErrors Code11',
      defaultMessage:
        'Attention: an error occurred. Please contact your system administrator for assistance.',
    }),
  },
  integration: {
    title: intl.formatMessage({
      description: 'MatchMaking V2 integration title',
      defaultMessage: 'CRM Integration',
    }),
    subtitle: intl.formatMessage({
      description: 'MatchMaking V2 integration subtitle',
      defaultMessage:
        'You can configure integrations with external CRMs supported by our platform.',
    }),
    cards: {
      linkText: intl.formatMessage({
        description: 'MatchMaking V2 integration cards linkText',
        defaultMessage: 'Documentation',
      }),
      linklurlSalesforce: intl.formatMessage({
        defaultMessage:
          'https://resources.salonemilano.it/docs/Manuale+Integrazione+Matchmaking+Salesforce_ENG.pdf',
        description: 'documentation url salesforce',
      }),
      linklurlHubspot: intl.formatMessage({
        defaultMessage:
          'https://resources.salonemilano.it/docs/Manuale+Integrazione+Matchmaking+HubSpot_ENG.pdf',
        description: 'documentation url salesforce',
      }),
      buttonText: intl.formatMessage({
        description: 'MatchMaking V2 integration cards buttonText',
        defaultMessage: 'Integrate',
      }),
      buttonText2: intl.formatMessage({
        description: 'MatchMaking V2 integration cards buttonText',
        defaultMessage: 'Request deactivation',
      }),
      salesforce: {
        title: intl.formatMessage({
          description: 'MatchMaking V2 integration cards salesforce title',
          defaultMessage: 'Salesforce',
        }),
        text: intl.formatMessage({
          description: 'MatchMaking V2 integration cards salesforce text',
          defaultMessage:
            "To set up the integration, click the 'Integrate' button and you will be redirected to the login page of the Salesforce portal where you can complete all the necessary steps.",
        }),
      },
      hubspot: {
        title: intl.formatMessage({
          description: 'MatchMaking V2 integration cards hubspot title',
          defaultMessage: 'HubSpot',
        }),
        text: intl.formatMessage({
          description: 'MatchMaking V2 integration cards hubspot text',
          defaultMessage:
            "To set up the integration, click the 'Integrate' button and you will be redirected to the login page of the Hubspot portal where you can complete all the necessary steps.",
        }),
      },
      crm: {
        title: intl.formatMessage({
          description: 'MatchMaking V2 integration cards crm title',
          defaultMessage: 'Connect Your CRM',
        }),
        text: intl.formatMessage({
          description: 'MatchMaking V2 integration cards crm text',
          defaultMessage:
            'If the CRM you use is not available, you can send us a request. Our team will evaluate the possibility of adding it to the supported integrations.',
        }),
        buttonText: intl.formatMessage({
          description: 'MatchMaking V2 integration cards crm buttonText',
          defaultMessage: 'Request Integration',
        }),
        chip: intl.formatMessage({
          description: 'Integrated',
          defaultMessage: 'Integrated',
        }),
      },
    },
  },
});
